export default "__VITE_ASSET__6499d3fa__"